// Converted from application/views/sculptures/fionnghuala-s_v.php. Edit this component directly.
export default function SculpturesFionnghualaSPage() {
  return <><div class={"firstContainer container photoLeft"}>
<figure class={"photo"}>
<img src={"/assets/images/sculptures/fionnghuala/Fionnghuala-S.jpg"} alt={"Fionnghuala"} />
<figcaption>{"#1"}</figcaption>
</figure>
<div class={"text"}>
<div>
<div class={"mainTitleWrp"}>
<h1>{"Fionnghuala "}<small>{"(S)"}</small></h1>
<h2>{"(Daughter of Lir)"}</h2>
<p>
<b>{"\n                        45H x 45L x 21W cm"}<br />{"\n                        Bronze\n                    "}</b>
</p>
</div>
</div>
</div>
</div>
<div class={"container fullPhoto"}>
<figure class={"photo"}>
<img src={"/assets/images/sculptures/fionnghuala/Fionnghuala-S-side.jpg"} alt={"Fionnghuala"} />
<figcaption>{"#2"}</figcaption>
</figure>
</div>
<div class={"container photoLeft"}>
<figure class={"photo"}>
<img src={"/assets/images/sculptures/fionnghuala/Fionnghuala-S-top.jpg"} alt={"Fionnghuala"} />
<figcaption>{"#3"}</figcaption>
</figure>
<div class={"text"}>
<div>
<p>{"\n                The oldest of four children of Lir, was the first to be transformed into a swan, under a spell cast by her jealous stepmother in this poignant Irish legend.\n            "}</p>
<p>{"\n                The four children were fated to spend 900 years flying as swans above the lakes of Ireland, after which they were to meet a holy monk, who would restore them to human form.\n            "}</p>
<p>{"\n                As soon as the monk had blessed them, they all turned to ashes. Fionnghuala shows defiance and courage as she leads the metamorphosis.\n            "}</p>
</div>
</div>
</div>
</>;
}
